<script>
import { Line } from 'vue-chartjs'

export default {   
    name: 'multi-line-graph',
    extends: Line,

    props: {
		name: {
			type: String,
			default: 'Line Graph'
		},
        data: {
            type: Array
        },
        dates: {
            type: Array
        },
        max: {
            type: Number
        }
    },


	mounted() {
		this.renderChart({
            labels:  this.dates, // Y axis
            datasets: this.data
        }, { responsive: true, maintainAspectRatio: false, 
                scales: {
                    yAxes: [{
                        display: true,
                        ticks: {
                            stepSize: 1,
                            min: 0,
                            max: this.max
                        }
                    }]
                },
                legend: {
                    display: true,
                    position: 'bottom'
                }
            }
        )
	},
    
    computed: {
        getLabels() {
            return this.data.map(d => d.date)
        }
    },
    
    components: {}
}
</script>

<style lang="scss" scoped>
</style>
